/*@ngInject*/
export default ['$resource', 'BASE_URL', function ($resource, BASE_URL) {
        return $resource(BASE_URL + "/settings/:resource/:code", {}, {
            'countries': { method: 'GET', isArray: true, params: { resource: "countries" } },
            'prices': { method: 'GET', isArray: true, params: { resource: "pricings" } },
        });
    }];
//# sourceMappingURL=pricing.service.js.map